import { createSlice } from "@reduxjs/toolkit";
import { colourToColourObjectType } from "../../utils/ColourGenerators/ColourToColourObjectType";

export interface manualColour {
  name: string | null;
  value: {
    rgb: {
      r: number;
      g: number;
      b: number;
    };
    hex: string;
    hsl: {
      h: number;
      s: number;
      l: number;
    };
  };
  category: any,
  associateColours: any,
}

interface manualColoursType {
  selectedColour: manualColour | null,
  manualColours: manualColour[]
}

const initialManualColourState: manualColoursType = {
  selectedColour: null,
  manualColours: [
    colourToColourObjectType("#0A2C37", "Colour 1"),
  ]
}
export const manualColourSlice = createSlice({
  name: "manualColours",
  initialState: initialManualColourState,
  reducers: {
    addToManualColours: (state, action) => {
      //@ts-ignore
      state.manualColours?.push(action.payload);
    },
    removeFromManualColours: (state, action) => {
      const newState: manualColour[] = []
      state.manualColours.map((e) => {
        if(e.name !== action.payload.name) newState.push(e)
      })
      state.manualColours = newState as manualColour[]
    },
    editManualColour: (state, action) => {
      state.manualColours.forEach((element: manualColour, index: number) => {
        if(element.name === action.payload.name){
          state.manualColours[index] = action.payload;
        }
      });
    },
    setManualSelectedColour: (state, action) => {
      state.selectedColour = action.payload;
    },
    removeManualSelectedColour: (state) => {
      state.selectedColour = null;
    },
    resetManualSelectedColour: (state) => {
      state.manualColours = [
        colourToColourObjectType("#0A2C37", "Colour 1"),
      ]
      state.selectedColour = colourToColourObjectType("#0A2C37", "Colour 1")
    }
  },
});

// Action creators are generated for each case reducer function
export const { addToManualColours, removeFromManualColours, editManualColour, setManualSelectedColour, removeManualSelectedColour, resetManualSelectedColour } =
  manualColourSlice.actions;

export default manualColourSlice.reducer;
